module.exports = __webpack_public_path__ + "static/boredom-09b656e8572819e300beb9cccabb057e.png";